import React from 'react'
import PropTypes from 'prop-types'

import { Button, ModalBox } from 't3-widgets'

import wfLogo from '../../../../data/img/webfleet-logo.svg'
import { getLazyLoadingDummyPage } from '../../../modules/main/app/components/pages/subscription-page/sub-pages/lazy-loading-dummy'

import styles from './modal.module.css'

const Modal = ({
    isLoading = false,
    children = 'Content',
    header = 'Header',
    showLogo = false,
    buttons = (
        <>
            <Button>Cancel</Button>
        </>
    ),
    isOpen = true
}) => {
    return (
        <ModalBox className={styles.modal} isOpen={isOpen}>
            {isLoading ? (
                getLazyLoadingDummyPage()
            ) : (
                <div className={styles.container}>
                    {showLogo ? (
                        <div className={styles.logo}>
                            <img className={styles.image} src={wfLogo} />
                        </div>
                    ) : (
                        <></>
                    )}
                    <div className={styles.header}>{header}</div>
                    <div className={styles.content}>{children}</div>
                    <div className={styles.buttons}>{buttons}</div>
                </div>
            )}
        </ModalBox>
    )
}

Modal.propTypes = {
    isLoading: PropTypes.bool,
    isOpen: PropTypes.bool,
    header: PropTypes.string,
    children: PropTypes.string,
    showLogo: PropTypes.bool,
    buttons: PropTypes.element
}

export { Modal }
